import { ItemType } from '@Utils/constants';

export enum FulfillmentStatus {
  COMPLETED = 'Completed',
  DELIVERED = 'Delivered',
  SAMPLE_COLLECTED = 'Sample Collected',
  REFUNDED = 'Refunded',
  CANCELLED = 'Cancelled',
  PENDING = 'Pending',
  DISPATCHED = 'Dispatched',
  REPORT_SHARED = 'Report Shared',
  REPORT_GENERATION_DELAYED = 'Report Generation Delayed',
  SCHEDULED = 'Scheduled',
}

export interface IFulfillmentItem {
  name?: string;
  typeId?: string;
  quantity?: number;
  paidAmount?: number;
  expectedTat?: string;
}

export interface IDrugTracking {
  received: string;
  packed: string;
  dispatched: string;
  delivered: string;
  expectedDeliveryTime: string;
  trackingUrl: string;
  shippingOrderId: string;
}

export interface ILabTracking {
  scheduled: string;
  prescribed: string;
  collectionScheduled: string;
  collected: string;
  reported: string;
}

export interface IFulfillment {
  id: string;
  serialNo: number;
  type: ItemType;
  name: string;
  billType: 'receipt' | 'refund' | 'sale';
  billTypes: ('receipt' | 'refund' | 'sale')[];
  fulfillmentType: 'delivery' | 'pickup';
  date: string;
  typeId: string;
  quantity: number;
  specificStatus?: string;
  status: FulfillmentStatus;
  paidAmount: number;
  consultationId?: string;
  encounterId?: string;
  invoiceId?: string;
  vendor?: {
    name?: string;
    address?: string;
    gstin?: string;
  };
  subItems?: IFulfillmentItem[];
  dueDate?: string;
  fxAddress?: string;
  fromAddress?: string;
  trackingDetails?: IDrugTracking & ILabTracking;
  trackingId?: string;
  trackingUrl?: string;
  location: { id: string; name: string };
  refunds?: IFulfillment[];
  venue?: string;
  locationId?: string;
  addressId?: string;
}
